/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    InventoryCategoryVm,
    InventoryCategoryVmFromJSON,
    InventoryCategoryVmFromJSONTyped,
    InventoryCategoryVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface InventoryCategoryVmPaginatedSearchResponse
 */
export interface InventoryCategoryVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<InventoryCategoryVm>}
     * @memberof InventoryCategoryVmPaginatedSearchResponse
     */
    items?: Array<InventoryCategoryVm> | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryCategoryVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryCategoryVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryCategoryVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryCategoryVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryCategoryVmPaginatedSearchResponse
     */
    size?: number;
}

export function InventoryCategoryVmPaginatedSearchResponseFromJSON(json: any): InventoryCategoryVmPaginatedSearchResponse {
    return InventoryCategoryVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function InventoryCategoryVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InventoryCategoryVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(InventoryCategoryVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function InventoryCategoryVmPaginatedSearchResponseToJSON(value?: InventoryCategoryVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(InventoryCategoryVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


